/* --------------------------- Table config start --------------------------- */
export const availableTablePageSizes = [10, 20, 50, 100]
export const defaultTablePageSize = 10
/* ---------------------------- Table config end ---------------------------- */